import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class TopicEstimateAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'TopicEstimates';

  /**
   * Lấy thông tin đề tài đã phát sinh
   * dtnga3 (22.04.2024)
   */
  getAriseTopic(id) {
    let request = {
      url: this.getAPIUrl() + '/topic',
      data: id,
    };

    return httpClient.getAsync(request);
  }
}

export default new TopicEstimateAPI();
